import { type FC } from 'react'

export const TosSuperscript: FC<{ value?: number }> = ({ value }) => {
  if (!value) {
    return null
  }

  return <sup>{value}</sup>
}
